// extracted by mini-css-extract-plugin
export default {"wrap":"Rz-z","fullWidth":"Sz-z","searchPlacement":"Tz-z","heading":"Uz-z","items":"Vz-z","featureCss":"Wz-z","disabled":"Xz-z","imgCss":"Yz-z"};